const CARD_PATTERNS = {
  visa: /^4/,
  mastercard: /^5[1-5]/,
  amex: /^3[47]/,
  discover: /^6(?:011|5)/,
  dinersclub: /^3(?:0[0-5]|[68])/,
  jcb: /^(?:2131|1800|35)/,
  // Common debit card patterns
  maestro: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/,
  visaDebit: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercardDebit: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)/,
};

const CARD_PROPERTIES = {
  amex: {
    maxLength: 15,
    cvvLength: 4,
  },
  default: {
    maxLength: 16,
    cvvLength: 3,
  },
};

export const detectCardType = (number) => {
  const cleanNumber = number.replace(/\D/g, "");

  for (const [card, pattern] of Object.entries(CARD_PATTERNS)) {
    if (pattern.test(cleanNumber)) {
      return card;
    }
  }

  return "";
};

export const getCardProperties = (type) => {
  return CARD_PROPERTIES[type] || CARD_PROPERTIES.default;
};

export const getCardTypeLabel = (cardType) => {
  if (!cardType) return "";
  return cardType.charAt(0).toUpperCase() + cardType.slice(1);
};
